import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { Cluster } from '../types/cluster';
import { EstablishmentClustersFilterProps } from '../types/clusterFilters';
import QueryString from "qs"
import usePrivateAxios from '@/common/api/usePrivateAxios';
import { EstablishmentMapAction } from '../types/action';
import { endpointFiltersForActions } from '../utils/endpointFiltersForActions';

export const useEstablishmentClusters = (filters: EstablishmentClustersFilterProps, action?: EstablishmentMapAction) => {
  const privateAxios = usePrivateAxios();
  const hasQueryParams = Object.keys(filters).length > 0;

  return useQuery({
    queryKey: ['establishmentClusters', filters, action?.name, ...(action ? Object.values(action?.properties || {}) : [])],
    queryFn: async () => {
      const queryString = QueryString.stringify({
        ...filters,
        ...endpointFiltersForActions(action),
      });

      const { data } = await privateAxios.get<{ data: Cluster[] }>(
        `/establishment/companies/geo_clustered?${queryString}`,
      );
      return data;
    },
    placeholderData: keepPreviousData,
    select: (returnedData) => returnedData?.data || [],
    enabled: hasQueryParams,
  });
};
